module.exports = __webpack_public_path__ + "static/img/cflp-logo.9450443a.png";